import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

export function useAssignedLessons() {
  const { user } = useAuth();
  const [assignedLessonIds, setAssignedLessonIds] = useState<string[]>([]);

  useEffect(() => {
    if (!user) return;

    const fetch = async () => {
      // Get teams the player belongs to
      const { data: memberships } = await supabase
        .from('team_members')
        .select('team_id')
        .eq('player_user_id', user.id);

      if (!memberships || memberships.length === 0) return;

      const teamIds = memberships.map(m => m.team_id);

      // Get lesson assignments for those teams
      const { data: assignments } = await supabase
        .from('lesson_assignments')
        .select('lesson_id')
        .in('team_id', teamIds);

      if (assignments) {
        const ids = [...new Set(assignments.map(a => a.lesson_id))];
        setAssignedLessonIds(ids);
      }
    };

    fetch();
  }, [user]);

  return assignedLessonIds;
}
